/* tslint:disable */

/**
 */
export class TempRecordPtsDef {
    AXIS2_AX_1_DEF?: number;
    ID_TEMP_RECORD_PTS_DEF?: number;
    AXIS1_PT_TOP_SURF_DEF?: number;
    AXIS2_PT_TOP_SURF_DEF?: number;
    AXIS3_PT_TOP_SURF_DEF?: number;
    AXIS1_PT_INT_PT_DEF?: number;
    AXIS2_PT_INT_PT_DEF?: number;
    AXIS3_PT_INT_PT_DEF?: number;
    AXIS1_PT_BOT_SURF_DEF?: number;
    AXIS2_PT_BOT_SURF_DEF?: number;
    AXIS3_PT_BOT_SURF_DEF?: number;
    ID_USER?: number;
    AXIS3_AX_1_DEF?: number;
    AXIS1_AX_2_DEF?: number;
    AXIS3_AX_2_DEF?: number;
    AXIS1_AX_3_DEF?: number;
    AXIS2_AX_3_DEF?: number;
    AXIS1_PL_2_3_DEF?: number;
    AXIS2_PL_1_3_DEF?: number;
    AXIS3_PL_1_2_DEF?: number;
    NB_STEPS_DEF?: number;
    CONTOUR2D_TEMP_MIN_DEF?: number;
    CONTOUR2D_TEMP_MAX_DEF?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temp-record-pts-def.ts